<template>
  <div class="form-group">
    <label :for="'question-' + id" class="font-weight-bold">{{ text }}</label>
    <textarea :id="'question-' + id" :placeholder="placeholder" :rows="rows"
              :value="value" @input="input" class="form-control" :maxlength="maxLength"></textarea>
    <small class="d-flex text-muted justify-content-end mt-1">{{ currentLength }}/{{ maxLength }}</small>
  </div>
</template>
<script>
export default {
  name: 'QuestionTextArea',
  data() {
    return {
      rows: 3,
      maxLength: 500
    }
  },
  props: ['question', 'value'],
  computed: {
    currentLength() {
      return (this.value || '').length
    },
    id() {
      return this.question.id
    },
    text() {
      return this.question.text
    },
    placeholder() {
      return this.question.description
    }
  },
  methods: {
    input(event) {
      this.$emit('update:value', event.target.value)
    }
  }
}
</script>
